import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import { Button, Stack, Typography } from "@mui/material"
import type { RefObject } from "react"
import { useTranslation } from "react-i18next"

import { DEFAULT_ENTRIES_LIMIT } from "../../../../api/hooks/vote"
import { useOffset } from "../offset-context"
import { useVoting } from "../vote-context"

interface Props {
	entriesContainer: RefObject<HTMLDivElement>
	isEnoughVotes: boolean
	loading: boolean
}

const BackForthPagination = ({ loading, entriesContainer }: Props) => {
	const { t } = useTranslation("vote")
	const { totalEntries } = useVoting()
	const { paginationOffset, setQueryOffset, currentPage, totalPages } =
		useOffset()

	const numericOffset = paginationOffset ?? 0

	const onClickBack = () => {
		setTimeout(() => {
			entriesContainer.current?.scrollIntoView({ block: "start" })
		}, 0)
		setQueryOffset(numericOffset - DEFAULT_ENTRIES_LIMIT)
	}

	const onClickForth = () => {
		setTimeout(() => {
			entriesContainer.current?.scrollIntoView({ block: "start" })
		}, 0)
		setQueryOffset(numericOffset + DEFAULT_ENTRIES_LIMIT)
	}

	return totalPages > 1 ? (
		<Stack
			direction='row'
			mb={5}
			gap={1.2}
			justifyContent='center'
			alignItems='center'
		>
			<Button
				sx={{
					minWidth: "24px",
					padding: "4px",
				}}
				variant='outlined'
				disabled={
					numericOffset <= 0 ||
					loading ||
					typeof paginationOffset !== "number"
				}
				onClick={onClickBack}
			>
				<ChevronLeftIcon />
			</Button>
			<Typography>
				{t("progress.pagination", {
					current: currentPage,
					total: totalPages,
				})}
			</Typography>
			<Button
				sx={{
					minWidth: "24px",
					padding: "4px",
				}}
				disabled={
					!(numericOffset + DEFAULT_ENTRIES_LIMIT < totalEntries) ||
					loading ||
					typeof paginationOffset !== "number"
				}
				variant='outlined'
				onClick={onClickForth}
			>
				<ChevronRightIcon />
			</Button>
		</Stack>
	) : null
}

export { BackForthPagination }
